import { Icon, List, Loader } from "semantic-ui-react";
import { Filter, PropertyFilter } from "../../../types/types";
import "./Filters.scss";
import { useState } from "react";
import FilterModal from "./FilterModal";
import FilterPill from "./FilterPill";
import { UsePropertyFilters } from "../../../hooks/usePropertyFilters";
import { useDataTableContext } from "../../../contexts/DataTableContext";
import Button from "../Button/Button";
import QuickSearch from "./QuickSearch";

interface FiltersProps extends UsePropertyFilters {}

export default function Filters({ filters, addFilter, updateFilterAt, removeFilterAt, clearFilters }: FiltersProps) {
	const { isLoadingAggregates } = useDataTableContext()!;
	const [isAddFilterModalOpen, setIsAddFilterModalOpen] = useState(false);
	const [editingFilterIndex, setEditingFilterIndex] = useState<number>();

	const onOpenAddFilterModal = (filterIndex?: number) => {
		setEditingFilterIndex(filterIndex);
		setIsAddFilterModalOpen(true);
	};

	const onCloseFilterModal = () => {
		setEditingFilterIndex(undefined);
		setIsAddFilterModalOpen(false);
	};

	const onSaveFilter = (filter: Filter | PropertyFilter) => {
		if (editingFilterIndex !== undefined) updateFilterAt(editingFilterIndex, filter);
		else addFilter(filter);

		onCloseFilterModal();
	};

	const onRemoveFilter = (index: number) => removeFilterAt(index);

	if (isLoadingAggregates)
		// NB: The filter pills need the aggregates to know how to display (eg what kind of filter each pill is dealing with), so return a preloader here until ready
		return <Loader inline active size="mini" className="filters" />;

	return (
		<>
			<div className="data-table-filter-container">
				<Icon name="filter" />
				<List horizontal>
					{filters.map((filter, index) => (
						<List.Item key={index}>
							<FilterPill
								filter={filter}
								onEdit={(filter) => onOpenAddFilterModal(index)}
								onRemove={() => onRemoveFilter(index)}
							/>
						</List.Item>
					))}
					<List.Item>
						<Button variant="contained tiny" title="Add filter" onClick={() => onOpenAddFilterModal()}>
							<Icon name="add" />
						</Button>
					</List.Item>
				</List>
			</div>
			{/* NB: Don't use open, handle it ourselves so that the component is recreated, updating it's initial state */}
			{isAddFilterModalOpen && (
				<FilterModal
					open={true}
					filter={editingFilterIndex !== undefined ? filters[editingFilterIndex] : undefined}
					onSaveFilter={onSaveFilter}
					onClose={onCloseFilterModal}
				/>
			)}
		</>
	);
}
